"use client";

import { useFormState, useFormStatus } from "react-dom";

import type { ButtonProps } from "@gsa/ui/button";
import { Button } from "@gsa/ui/button";
import { Icons, PlusIcon } from "@gsa/ui/icons";
import { cn } from "@gsa/ui/lib/utils";

import { addItem } from "~/lib/actions";

function SubmitButton({
  availableForSale,
  productId,
  ...props
}: {
  availableForSale: boolean;
  productId: string;
} & ButtonProps) {
  const { pending } = useFormStatus();

  if (!availableForSale) {
    return (
      <Button aria-disabled variant="ghost">
        Out Of Stock
      </Button>
    );
  }

  if (!productId) {
    return (
      <Button
        aria-label="Please select an option"
        aria-disabled
        variant="ghost"
      >
        <div className="absolute left-0 ml-4">
          <PlusIcon className="h-5" />
        </div>
        Add To Cart
      </Button>
    );
  }

  return (
    <Button
      size="lg"
      variant="success"
      {...props}
      onClick={(e: React.FormEvent<HTMLButtonElement>) => {
        if (pending) e.preventDefault();
      }}
      aria-label="Add To Cart"
      aria-disabled={pending}
      className="w-full"
      title="Add To Cart"
      name="Add To Cart"
    >
      <div className="absolute left-0 ml-4">
        {pending ? (
          <Icons.spinner className="h-4 w-4" />
        ) : (
          <PlusIcon className="h-5" />
        )}
      </div>
      Add To Cart
    </Button>
  );
}

export function AddToCart({
  productId,
  availableForSale,
  ...props
}: {
  productId: string;
  availableForSale: boolean;
} & ButtonProps) {
  // @ts-expect-error Error
  const [message, formAction] = useFormState(addItem, null);
  // @ts-expect-error Error
  const actionWithVariant = formAction.bind(null, productId);

  return (
    <form
      action={actionWithVariant}
      className={cn("flex flex-1", props.className)}
    >
      <input type="hidden" name="productId" value={productId} />
      <SubmitButton
        availableForSale={availableForSale}
        productId={productId}
        {...props}
        variant="blue"
      />
      <p aria-live="polite" className="sr-only" role="status">
        {message}
      </p>
    </form>
  );
}
